define('extensions/knockout/functions/difference', [
    'knockout'
], (ko) => {
    /**
     * calls function with observable value as argument
     */
    ko.subscribable.fn.difference = function (other) {
        return ko.pureComputed(() => _(this()).difference(ko.unwrap(other)));
    }      
});